import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { int32_type, record_type, bool_type, option_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { optToStr } from "../../Utils.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";

export class ContractEndUserDTO extends Record {
    constructor(FirstName, MiddleName, LastName, PostalAttention, PostalStreetAddress, PostalCode, PostalCity, PostalCountryCode, OnlyInvoiceeData) {
        super();
        this.FirstName = FirstName;
        this.MiddleName = MiddleName;
        this.LastName = LastName;
        this.PostalAttention = PostalAttention;
        this.PostalStreetAddress = PostalStreetAddress;
        this.PostalCode = PostalCode;
        this.PostalCity = PostalCity;
        this.PostalCountryCode = PostalCountryCode;
        this.OnlyInvoiceeData = OnlyInvoiceeData;
    }
}

export function ContractEndUserDTO$reflection() {
    return record_type("Containers.NumberDirectory.Model.ContractEndUserDTO", [], ContractEndUserDTO, () => [["FirstName", option_type(string_type)], ["MiddleName", option_type(string_type)], ["LastName", option_type(string_type)], ["PostalAttention", option_type(string_type)], ["PostalStreetAddress", option_type(string_type)], ["PostalCode", option_type(string_type)], ["PostalCity", option_type(string_type)], ["PostalCountryCode", option_type(string_type)], ["OnlyInvoiceeData", option_type(bool_type)]]);
}

export class NumberDirectoryDTO extends Record {
    constructor(ContractNr, Number$, CreatedAtUtc, ToSendAfterUTC, SentAtUtcDirService, ContractEndUser, SendInfo) {
        super();
        this.ContractNr = (ContractNr | 0);
        this.Number = Number$;
        this.CreatedAtUtc = CreatedAtUtc;
        this.ToSendAfterUTC = ToSendAfterUTC;
        this.SentAtUtcDirService = SentAtUtcDirService;
        this.ContractEndUser = ContractEndUser;
        this.SendInfo = SendInfo;
    }
}

export function NumberDirectoryDTO$reflection() {
    return record_type("Containers.NumberDirectory.Model.NumberDirectoryDTO", [], NumberDirectoryDTO, () => [["ContractNr", int32_type], ["Number", string_type], ["CreatedAtUtc", option_type(string_type)], ["ToSendAfterUTC", option_type(string_type)], ["SentAtUtcDirService", option_type(string_type)], ["ContractEndUser", option_type(ContractEndUserDTO$reflection())], ["SendInfo", option_type(string_type)]]);
}

export function NumberDirectoryDTO_GetId_ZC91B2B1(dto) {
    const arg_2 = optToStr(dto.ToSendAfterUTC);
    return toText(printf("%i-%s-%s"))(dto.ContractNr)(dto.Number)(arg_2);
}

